import React from 'react';
import MkIcon from '../MkIcon';
import MkPill from '../MkPill';

const TIERS = [
  { text: 'Adult-content blocking', pill: 'free' },
  { text: 'Your own list of sites to block, plus an always-allow list', pill: 'premium' },
  { text: 'Keywords (Android only)', pill: 'premium' },
  {
    text: "Strict mode: keep blocking switched on for a time you choose. While it runs, blocking can't be turned off or weakened in the app.",
    pill: 'premium',
  },
];

// B4 — website blocking on the phone itself. Abstract shield visual only: no fake app screen and no
// desktop browser imagery.
const BmbSites = () => (
  <section className="mk-sites section" id="blocking" aria-labelledby="mk-sites-title">
    <div className="container">
      <div className="section-inner">
        <div className="mk-sites__top">
          <div className="mk-sites__text reveal-from-left">
            <p className="mk-eyebrow">Blocking</p>
            <h2 id="mk-sites-title" className="mk-h2">
              Block adult content for free. Add the sites that pull you in with Premium.
            </h2>
            <p className="mk-lead">Not a browser extension — Bring Me Back filters websites on the phone itself.</p>
            <ul className="list-reset mk-tiers">
              {TIERS.map((t) => (
                <li key={t.text} className="mk-tiers__item">
                  <span className="mk-tiers__check">
                    <MkIcon name="check" size={18} />
                  </span>
                  <span className="mk-tiers__text">{t.text}</span>
                  <MkPill variant={t.pill}>{t.pill === 'free' ? 'Free' : 'Premium'}</MkPill>
                </li>
              ))}
            </ul>
          </div>
          <div className="mk-sites__visual reveal-scale-up" aria-hidden="true">
            <div className="mk-shield">
              <span className="mk-shield__ring mk-shield__ring--1" />
              <span className="mk-shield__ring mk-shield__ring--2" />
              <span className="mk-shield__ring mk-shield__ring--3" />
              <span className="mk-shield__core">
                <MkIcon name="shield" size={72} />
              </span>
              <span className="mk-shield__pill mk-shield__pill--1">Adult content · Free</span>
              <span className="mk-shield__pill mk-shield__pill--2">Your sites · Premium</span>
              <span className="mk-shield__pill mk-shield__pill--3">Strict mode · Premium</span>
            </div>
          </div>
        </div>
        <div className="mk-sites__platforms">
          <div className="reveal-from-bottom" data-reveal-delay="0">
            <div className="mk-card mk-sites__card">
              <h3 className="mk-h3">Android</h3>
              <p className="mk-body">
                Works across your browsers and apps with an on-device filter built on Android's VPN permission. There is no
                remote VPN server.
              </p>
            </div>
          </div>
          <div className="reveal-from-bottom" data-reveal-delay="120">
            <div className="mk-card mk-sites__card">
              <h3 className="mk-h3">iPhone (iOS 16 or later)</h3>
              <p className="mk-body">
                Uses Apple's Screen Time web filter for Safari and in-app browsers. Adult-content blocking uses Apple's own
                filter, and your own sites are blocked as whole domains.
              </p>
            </div>
          </div>
        </div>
        <p className="mk-sites__privacy">
          Filtering happens entirely on your phone: no browsing data, domains or DNS lookups leave it.
        </p>
        <p className="mk-micro mk-sites__caveat">
          <MkIcon name="info" size={18} />
          <span>
            No filter catches everything. On Android, sites using encrypted DNS, another active VPN, or apps with their own
            DNS settings may not be filtered, and only one VPN can run at a time. Bring Me Back doesn't block sites on your
            computer.
          </span>
        </p>
      </div>
    </div>
  </section>
);

export default BmbSites;
